module.exports = __webpack_public_path__ + "static/img/zhuhaibei.552999b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/jiaotong/zhuhaibei.jpg
// module id = aYVi
// module chunks = 1